import React from 'react'
import { StaticQuery, graphql } from 'gatsby'
import { Heading, Box, Container, Flex } from '@magicsoup.io/stock'
import Image from 'gatsby-image'

import {
  P,
  MobileFlex,
  Img,
  Target
} from '../../styled'


class AppSection extends React.Component {
  onPlayStoreClickHandler = () => {
    typeof window !== "undefined" && window.gtag('event', 'clickPlayStoreLinkCTA',{
      'event_category':'engagement',
      'event_label': 'outboundStoreButton',
      'event_value': 10
    })
  }

  onAppStoreClickHandler = () => {
    typeof window !== "undefined" && window.gtag('event', 'clickAppStoreLinkCTA',{
      'event_category':'engagement',
      'event_label': 'outboundStoreButton',
      'event_value': 10
    })
  }

  render() {
    return(
      <StaticQuery
        query={graphql`
          query appInfoQuery {
            site {
              siteMetadata {
                playStoreLink
                appStoreLink
                googleTrackingId
              }
            }
            generalJson {
              app { 
                claim
                info
                outcome
              }
            }
            playStore:file(relativePath: { eq: "assets/play-store.svg" }) {
              publicURL
            }
            appStore:file(relativePath: { eq: "assets/app-store.svg" }) {
              publicURL
            }
            mobile:file(relativePath: { eq: "assets/iPhone-X-Mockup.png" }) {
              childImageSharp {
                fixed {
                  ...GatsbyImageSharpFixed
                }
              }
            }
          }
        `}
        render={data => (
          <Box bg="#f5f5f5">
            <Container>
              <Flex flexWrap="wrap" alignItems="center" mt="3em" pt={[3,4,4]} pb={[4,0,0]}>
                <Flex width={[1,1,1/2]} flexDirection="column" alignItems="center" px={[2]}>
                  <Heading as="h1">{data.generalJson.app.claim}</Heading>
                  <P center>{data.generalJson.app.info}</P>
                  <P center py={[4]}>{data.generalJson.app.outcome}</P>
                  <Flex width={[1]} justifyContent="space-evenly" flexWrap="wrap">
                    <Target href={data.site.siteMetadata.appStoreLink} target="_blank" 
                      onClick={() => this.onAppStoreClickHandler()}>
                      <Img m={[3]} src={data.appStore.publicURL} />
                    </Target>
                    <Target href={data.site.siteMetadata.playStoreLink} target="_blank" 
                      onClick={() => this.onPlayStoreClickHandler()}>
                      <Img m={[3]} src={data.playStore.publicURL} />
                    </Target>
                  </Flex>
                </Flex>
    
                <MobileFlex width={[1,1,1/2]} justifyContent="center" hideMobile>
                  <Image fixed={data.mobile.childImageSharp.fixed} />
                </MobileFlex>
              </Flex>
            </Container>
          </Box>
        )}
      />
    )
  }
}

export default AppSection
